module.exports = __webpack_public_path__ + "static/Solrise-4ebad21321871278ef26f0645320399a.svg";